module.exports = __webpack_public_path__ + "static/media/smoke.cd5d98bb.svg";